var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.6114,
    height: 12.2598,
    viewBox: "0 0 21.6114 12.2598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1183",
    d: "M1.00006 7.26987C3.06912 7.08178 5.13818 6.89368 7.89693 6.79678C10.6557 6.69988 14.0414 6.69988 16.0677 6.60583C18.094 6.51179 18.6583 6.32369 19.2397 6.12989",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1184",
    d: "M14.6798 1.00001C17.6893 3.63336 19.804 5.17803 20.4708 5.74517C20.1972 6.6885 19.2454 7.83418 18.1082 8.87726C17.5354 9.35605 16.9711 9.73224 15.2497 11.2598",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrowIcon);
export default __webpack_public_path__ + "static/media/forward-arrow-icon.a6baa30394416098db38e200bf687cac.svg";
export { ForwardRef as ReactComponent };